import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import { sessionTimingAction } from "./sessionTimingSlice";
import { logoutUser } from "../../utils";
import { toast } from "react-toastify";

function* handleSessionTimer(){
    while(true){
        yield delay(1000);
        const timeLeft = yield select((state) => state.sessionTiming.sessionTimeLeft);
        if (timeLeft > 0) {
            yield put(sessionTimingAction.decreaseSessionTime());
        } else {
            // If localStorage has no sessionEndTime, the session was cleared
            // intentionally (e.g., diagnostic test completed) — just exit.
            // Otherwise it's a real timeout and the user should be logged out.
            const endTime = typeof localStorage !== "undefined"
                ? localStorage.getItem("sessionEndTime")
                : null;
            if (!endTime) {
                break;
            }
            yield put(sessionTimingAction.setSessionTimedOut());
            toast.error("Session timed out. You will be logged out.", { autoClose: 3000 });
            yield delay(3000);
            yield call(logoutUser);
            break;
        }
    }
}

export function* sessionWatcherSaga(){
    yield takeLatest(sessionTimingAction.startSessionTimer.type, handleSessionTimer)
}
